import type { SolutionModel } from "../types/solution";
import { SolutionColors } from "@smartsuite/types/lib/constants/color";

export const buildDefaultSolution = (solutionId: string): SolutionModel => ({
  name: "New Solution2",
  slug: "suwapje4",
  logo_color: SolutionColors.darkPrimaryGrey,
  logo_icon: "apple-crate",
  // description: {
  //   data: {},
  //   html: "",
  //   preview: "",
  // },
  //   permissions: {
  //     level: "all_members",
  //     members: [],
  //     teams: [],
  //     owners: ["60b0d6dce088d203177ff973"],
  //   },
  hidden: false,
  created: "2022-01-05T17:56:14.382000Z",
  created_by: "60b0d6dce088d203177ff973",
  updated: "2022-03-14T13:05:44.297000Z",
  updated_by: "60b0d6dce088d203177ff973",
  automation_count: 1,
  last_access: "2022-07-25T09:57:43.356108Z",
  id: solutionId ?? "61d5dbbe78d2ec23144d0413",
  delete_date: null,
  deleted_by: null,
  template: null,
});

export const EMPTY_SOLUTION: SolutionModel = {
  name: "",
  slug: "",
  logo_color: SolutionColors.darkPrimaryGrey,
  logo_icon: "",
  // description: {
  //   data: {},
  //   html: "",
  //   preview: "",
  // },
  hidden: false,
  created: "",
  created_by: "",
  updated: "",
  updated_by: "",
  automation_count: 0,
  last_access: "",
  id: "",
  delete_date: null,
  deleted_by: null,
  template: null,
};
